var exports = {
  "kL": "StickerGridItem.module__container___S3pEdW",
  "Bd": "StickerGridItem.module__stickerWrapper___S3pEdW",
  "HF": "StickerGridItem.module__stickerImage___S3pEdW",
  "Qs": "StickerGridItem.module__content___S3pEdW",
  "wx": "StickerGridItem.module__header___S3pEdW",
  "Zl": "StickerGridItem.module__stickerName___S3pEdW",
  "mr": "StickerGridItem.module__authorInfo___S3pEdW",
  "Du": "StickerGridItem.module__authorAvatar___S3pEdW",
  "fh": "StickerGridItem.module__authorName___S3pEdW",
  "o1": "StickerGridItem.module__actions___S3pEdW",
  "hP": "StickerGridItem.module__actionButton___S3pEdW" + " " + __webpack_require__(80357)["AS"] + " " + __webpack_require__(80357)["ik"],
  "G5": "StickerGridItem.module__deleteButton___S3pEdW",
  "Kk": "StickerGridItem.module__icon___S3pEdW",
};

module.exports = exports;
